import { WalletOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Form,
  Input,
  message,
  Radio,
  Select,
  Tabs,
  Upload,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { API } from "src/shared";
import { NomenclatureContext } from "src/shared/lib/hooks/context/getNomenclatureContext";

import debounce from "lodash.debounce";
import { apiRequests } from "src/shared/api/api";

const formItemLayout = { labelCol: { span: 5 }, wrapperCol: { span: 17 } };

export default function Nomenclature({
  formContext,
  record,
  handleSaveImage,
  handleDeleteImage,
  setChangeData,
  withoutImage = false,
}) {
  const {
    manufacturersData = [],
    categoriesData = [],
    unitsData = [],
    token,
  } = useContext(NomenclatureContext);
  const [manufacturers, setManufacturers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pictures, setPictures] = useState([]);
  const [units, setUnits] = useState([]);
  const [nomenclature, setNomenclature] = useState([]);
  const [optionsName, setOptionsName] = useState([]);
  const [cashbackType, setCashbackType] = useState(
    record && record.cashback_type ? record.cashback_type : null
  );

  const types = [
    { value: "product", label: "Товар" },
    { value: "service", label: "Услуга" },
    { value: "offer", label: "Предложение" },
    { value: "resourse", label: "Ресурс" },
    { value: "rental", label: "Аренда" },
    { value: "property", label: "Недвижимость" },
  ];

  const { TextArea } = Input;

  const getNomenclature = API.crud.get(token, "/nomenclature");

  const validateMessages = {
    /* eslint-disable no-template-curly-in-string */
    required: "Поле обязательно для ввода!",
  };

  const onChangeName = (e) => {
    setOptionsName(
      nomenclature.filter((n) =>
        n.value.toLowerCase().includes(e.toLowerCase())
      )
    );
  };

  const debounceOnChangeName = debounce(onChangeName, 500);

  useEffect(() => {
    if (unitsData.length !== 0) {
      const unitsSelect = [];
      for (let item of unitsData) {
        unitsSelect.push({ value: item.id, label: item.name });
      }
      setUnits(unitsSelect);
    }
    if (manufacturersData.length !== 0) {
      const manufacturersSelect = [];
      for (let item of manufacturersData) {
        manufacturersSelect.push({ value: item.id, label: item.name });
      }
      setManufacturers(manufacturersSelect);
    }
    if (categoriesData.length !== 0) {
      const categoriesSelect = [];
      for (let item of categoriesData) {
        categoriesSelect.push({ value: item.id, label: item.name });
      }
      setCategories(categoriesSelect);
    }
    if (record?.pictures !== undefined && record?.pictures.length !== 0) {
      const picturesDefault = [];
      for (let item of record.pictures) {
        picturesDefault.push({
          id: item.id,
          name: item.url,
          status: "done",
          url: `https://${process.env.REACT_APP_APP_URL}/api/v1/${item.url}/`,
        });
      }
      setPictures(picturesDefault);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manufacturersData, categoriesData, unitsData]);

  useEffect(() => {
    const initial = async () => {
      await getNomenclature().then((res) =>
        setNomenclature(res.result.map((el) => ({ value: el.name })))
      );
    };

    if (!nomenclature.length) {
      initial();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (record?.id) {
      apiRequests.pictures
        .getItems({
          entity: "nomenclature",
          entity_id: record.id,
        })
        .then((response) => {
          setPictures(
            response.data.result.map((item) => ({
              id: item.id,
              name: item.url,
              status: "done",
              url: `https://${process.env.REACT_APP_APP_URL}/api/v1/${item.url}/`,
            }))
          );
        });
    }
  }, [record?.id]);

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onValuesChange = () => {
    setChangeData(true);
  };

  return (
    <Form
      {...formItemLayout}
      form={formContext}
      initialValues={record}
      onValuesChange={onValuesChange}
      layout={"horizontal"}
      style={{ maxWidth: "100%" }}
      validateMessages={validateMessages}
    >
      <Tabs>
        <Tabs.TabPane tab="Основное" key="main">
          <Form.Item rules={[{ required: true }]} label={"Имя"} name={"name"}>
            <AutoComplete
              options={optionsName}
              onChange={debounceOnChangeName}
            />
          </Form.Item>
          <Form.Item label={"Тип"} name={"type"}>
            <Radio.Group style={{ display: "flex", width: "100%" }}>
              {types.map((t) => (
                <Radio.Button
                  key={t.value}
                  value={t.value}
                  style={{
                    flex: "1",
                    textAlign: "center",
                    padding: "0 16px",
                    fontSize: "13px",
                  }}
                >
                  {t.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Form.Item>
          <Form.Item label="Теги" name="tags">
            <Select
              mode="tags"
              style={{ width: "100%" }}
              tokenSeparators={[","]}
            />
          </Form.Item>
          <Form.Item label={"Краткое описание"} name={"description_short"}>
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item label={"Длинное описание"} name={"description_long"}>
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item label={"Код"} name={"code"}>
            <Input />
          </Form.Item>
          <Form.Item label={"Единица измерения"} name={"unit"}>
            <Select filterOption={filterOption} showSearch options={units} />
          </Form.Item>
          <Form.Item label={"Категория"} name={"category"}>
            <Select
              filterOption={filterOption}
              showSearch
              options={categories}
            />
          </Form.Item>
          <Form.Item label={"Производитель"} name={"manufacturer"}>
            <Select
              filterOption={filterOption}
              showSearch
              options={manufacturers}
            />
          </Form.Item>
          <Form.Item label={"Тип кешбека"} name={"cashback_type"}>
            <Select value={cashbackType} onChange={setCashbackType}>
              <Select.Option value={"percent"}>Проценты</Select.Option>
              <Select.Option value={"const"}>Постоянный</Select.Option>
              <Select.Option value={"lcard_cashback"}>
                По карте лояльности
              </Select.Option>
              <Select.Option value={"no_cashback"}>Отсутствует</Select.Option>
            </Select>
          </Form.Item>
          {cashbackType === "percent" || cashbackType === "const" ? (
            <Form.Item label={"Кешбек"} name={"cashback_value"}>
              <Input
                placeholder={
                  cashbackType === "percent"
                    ? "В процентах"
                    : cashbackType === "const"
                    ? "В баллах"
                    : ""
                }
                addonAfter={
                  cashbackType === "percent" ? "%" : <WalletOutlined />
                }
              />
            </Form.Item>
          ) : null}
          {!withoutImage ? (
            <Form.Item label={"Изображение"}>
              <Upload
                action={`https://${process.env.REACT_APP_APP_URL}/api/v1/pictures/?token=${token}&entity=nomenclature&entity_id=${record.id}`}
                fileList={pictures}
                listType="picture-card"
                onChange={({ fileList: newFileList, file: newFile }) => {
                  if (newFile.status === "done") {
                    handleSaveImage(newFile.response);
                    setPictures(newFileList);
                    return message.success("Изображение было добавлено");
                  }
                  setPictures(newFileList);
                }}
                onRemove={(picture) => {
                  if (picture.response !== undefined) {
                    return handleDeleteImage(picture.response.id);
                  }
                  handleDeleteImage(picture.id);
                }}
              >
                <Button>Загрузить</Button>
              </Upload>
              {/* <div style={{padding: '10px 0', display: 'flex', gap: 10}}>
            {
              pics.map(pic => <PreviewImage items={[pic]} width={60} height={60} key={pic.id} />)
            }
          </div> */}
            </Form.Item>
          ) : null}
        </Tabs.TabPane>
        <Tabs.TabPane tab="SEO" key="seo">
          <Form.Item label={"SEO Title"} name={"seo_title"}>
            <Input placeholder="Заголовок для поисковиков" />
          </Form.Item>

          <Form.Item label={"SEO Description"} name={"seo_description"}>
            <TextArea rows={3} placeholder="Краткое описание для поисковиков" />
          </Form.Item>

          <Form.Item label={"SEO Keywords"} name={"seo_keywords"}>
            <Select
              mode="tags"
              style={{ width: "100%" }}
              tokenSeparators={[","]}
              placeholder="Ключевые слова"
            />
          </Form.Item>
        </Tabs.TabPane>
      </Tabs>
    </Form>
  );
}
